import { ComponentBase } from '../../../component-base';
import { IMouseDown, IMouseMove, IKeyDown, IMouseRelease, IDoubleClick } from '../Interfaces';
import { Injectable } from '@angular/core';
import { StageService } from '../../stage.service';
import { DrawingsHolderService } from '../drawings-holder.service';
import { ComponentsList } from '../ComponentsList';

@Injectable()
export class RootComponent extends ComponentBase
  implements IMouseDown, IMouseMove, IKeyDown, IMouseRelease, IDoubleClick {

  saved: boolean = false;

  constructor(
    private stage: StageService,
    private drawings: DrawingsHolderService,
    private componentList: ComponentsList
  ) {
    super();
    this.drawings.saved.subscribe(value => {
      this.saved = value;
    });
  }

  private invokeMethod(methodName: string, eventArg: Event): boolean {
    const components = this.componentList;
    let component, i = 0, method, stop = false;
    for (; i < components.length; i++) {
      component = components[i];
      method = component[methodName];
      if (component.isEnabled() && method) {
        stop = method.call(component, eventArg);
        if (stop) {
          break;
        }
      }
    }
    return stop;
  }

  mouseDown(e: MouseEvent) {
    if (e.button === 0) {
      return !this.invokeMethod('mouseDown', e);
    }
    return true;
  }

  mouseMove(e: MouseEvent) {
    return !this.invokeMethod('mouseMove', e);
  }

  mouseUp(e: MouseEvent) {
    return !this.invokeMethod('mouseUp', e);
  }

  keyDown(e: KeyboardEvent) {
    return !this.invokeMethod('keyDown', e);
  }

  dblclick(e: MouseEvent) {
    return !this.invokeMethod('dblclick', e);
  }

  enable() {
    super.enable();
    if (this.saved) {
      this.drawings.canvas.visible = true;
    } else {
      this.drawings.clear();
      this.stage.remove(this.drawings.canvas);
      const p = this.drawings.paperBox;
      
      this.drawings.canvas.visible = true;
      this.drawings.initialize();
      this.stage.add(this.drawings.canvas);
    }
  }

  disable() {
    super.disable();
    if (this.saved) {
      this.drawings.canvas.visible = false;
    } else {
      this.drawings.clear();
      this.stage.remove(this.drawings.canvas);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/RootComponent.ts